const API_URL = "https://lets-manage-7d2ea4f309ff.herokuapp.com";

export async function getTeamsByUser(username) {
    if (!username) {
        throw new Error('Username not found in localStorage');
    }
    const url = `${API_URL}/users/${username}/teams`;

    try {
        const response = await fetch(url, {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.error || "Error obtaining user teams");
        }

        return await response.json();
    } catch (error) {
        console.error("Error in getTeamsByUser:", error);
        throw error;
    }
}